import { makeStyles } from '@material-ui/styles'

const styles = makeStyles((theme) => ({
  category: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: '1.4rem',
  },
  selected: {
    color: theme.palette.primary,
    fontWeight: 'bold',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 5,
  }
}))

export default styles
